var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nvd3-line bar-chart text-center",attrs:{"id":_vm.barchart_id,"data-x-grid":"false"}},[_c('svg')])
}
var staticRenderFns = []

export { render, staticRenderFns }